import { ReactNode } from "react";

type IconType = {
  width: number;
  height: number;
  stroke?: string;
  fill?: string;
  className?: string;
  children?: ReactNode;
  onClick?: () => void;
};

export const HamburgerIconOutline = ({ width, height, stroke }: IconType) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 17H20M4 12H20M4 7H20" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const ArrowLeftIconOutline = ({ width, height, stroke }: IconType) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 7L10 12" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 17L10 12" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const SearchIconOutline = ({ width, height, fill }: IconType) => {
  return (
    <svg width={width} height={height} viewBox={`0 0 10 10`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_357_31542)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.90295 1.53247C3.04162 1.53247 1.53271 3.04137 1.53271 4.9027C1.53271 6.76403 3.04162 8.27294 4.90295 8.27294C6.76428 8.27294 8.27318 6.76403 8.27318 4.9027C8.27318 3.04137 6.76428 1.53247 4.90295 1.53247ZM0.782715 4.9027C0.782715 2.62716 2.62741 0.782471 4.90295 0.782471C7.17849 0.782471 9.02318 2.62716 9.02318 4.9027C9.02318 7.17825 7.17849 9.02294 4.90295 9.02294C2.62741 9.02294 0.782715 7.17825 0.782715 4.9027Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.2423 7.43733C7.38856 7.29069 7.626 7.29038 7.77263 7.43664L9.24098 8.90117C9.38761 9.04743 9.38792 9.28486 9.24167 9.4315C9.09541 9.57814 8.85797 9.57844 8.71134 9.43219L7.24299 7.96766C7.09636 7.8214 7.09605 7.58397 7.2423 7.43733Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_357_31542">
          <rect width="10" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CloseIconOutline = ({ width, height, stroke }: IconType) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.66663 4.6665L11.3333 11.3332" stroke={stroke} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.3333 4.6665L4.66663 11.3332" stroke={stroke} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const PlusLocationIcon = ({ width, height, stroke, className = "" }: IconType) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M5.66669 7.33333H10.3334M8.00002 5V9.66667M13.3334 7.33333C13.3334 10.0952 11.234 12.3668 8.54393 13.7385C8.20216 13.9127 7.79788 13.9127 7.45611 13.7385C4.76608 12.3668 2.66669 10.0952 2.66669 7.33333C2.66669 4.38781 5.0545 2 8.00002 2C10.9455 2 13.3334 4.38781 13.3334 7.33333Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditIcon = ({ width, height, stroke }: IconType) => {
  return (
    <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.22216 2.84373L2.72294 7.34296C2.39361 7.67228 2.1336 8.07204 2.05444 8.53099C1.97451 8.9944 1.94792 9.56949 2.22216 9.84374C2.49641 10.118 3.07149 10.0914 3.5349 10.0115C3.99386 9.9323 4.39361 9.67228 4.72294 9.34296L9.22216 4.84373M7.22216 2.84373C7.22216 2.84373 8.72216 1.34373 9.72216 2.34373C10.7222 3.34373 9.22216 4.84373 9.22216 4.84373M7.22216 2.84373L9.22216 4.84373"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const InfoCircleIcon = ({ width, height, stroke, className = "" }: IconType) => {
  return (
    <svg width={width} height={height} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M12.5 7.01001V7.00002M12.5 17L12.5 10M21.5 12C21.5 16.9706 17.4706 21 12.5 21C7.52944 21 3.5 16.9706 3.5 12C3.5 7.02944 7.52944 3 12.5 3C17.4706 3 21.5 7.02944 21.5 12Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PlusIcon = ({ width, height, stroke }: IconType) => {
  return (
    <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 3.5V8.5M3.5 6H8.5" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
